(async () => {
    const { Core } = await importModule('Core');
    const { fetchHTML, $replaceContent } = await importModule('Utils');

    customElements.define('collection-provider', class extends Core {

        elements = {
            form: '[data-collection-form]',
            drawerForm: '[data-collection-drawer-form]',
            dynamicBlocks: '*[data-collection-dynamic-block]'
        }

        subscriptions = {
            'filter:change': '_onFilterChange',
            'navigation:change': '_onFilterChange'
        }

        cache = {};

        render() {
            this.subscribe('filter:change');
            this.subscribe('navigation:change');

            // Add popstate event listener to handle browser back/forward navigation
            window.addEventListener('popstate', this._onHistoryChange.bind(this));
        }

        async _onFilterChange(data) {
            this._getUrlParams(data);
            this._updateHistory();
            this._scrollToTop();
            await this._updateDynamicBlocks();
        }

        _getUrlParams(data) {
            this.urlParams = data?.url
                ? new URL(`${window.location.origin}${data.url}`).searchParams
                : new URLSearchParams(new FormData(this.$currentForm));
        }

        _debounce(func, wait = 100) {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        }

        _updateHistoryDebounced = this._debounce(() => {
            window.history.pushState({}, null, `${window.location.pathname}?${this.urlParams.toString()}`);
        });

        _updateHistory() {
            this._updateHistoryDebounced();
        }

        async _updateDynamicBlocks() {
            await this._getDoc();
            this.$dynamicBlocks.map($block => {
                $replaceContent(
                    $block,
                    this.doc.getElementById($block.id)
                );
            });

        }

        async _getDoc() {
            const urlParamsStr = this.urlParams.toString();
            if(this.cache[urlParamsStr]) {
                this.doc = this.cache[urlParamsStr];
            } else {
                this.publish('collection:loading');
                await this._fetchDoc(urlParamsStr);
            }
            this.publish('collection:updated', {
                doc: this.doc
            })
        }

        async _fetchDoc(urlParamsStr) {
            const fetchParams = new URLSearchParams(urlParamsStr);
            fetchParams.append('section_id', this.sectionId);
            this.doc = await fetchHTML(`${this.getAttribute('collection-url')}?${fetchParams.toString()}`);
            this.cache[urlParamsStr] = this.doc;
        }

        _scrollToTop() {
            window.scrollTo({
                top: this.topPoint,
                behavior: 'smooth',
            });
        }

        get topPoint() {
            const headerHeight = document.documentElement.style.getPropertyValue('--header-height')?.replace('px', '');
            return headerHeight ? this.offsetTop - headerHeight : this.offsetTop;
        }

        get $currentForm() {
            if(!this.$form) {
                return this.$drawerForm;
            }
            return this.onMobile ? this.$drawerForm : this.$form;
        }

        get onMobile() {
            return window.matchMedia('(max-width: 992px)').matches;
        }

        async _onHistoryChange() {
            // Get current URL search params
            this.urlParams = new URLSearchParams(window.location.search);

            // Update the collection content based on the URL
            await this._updateDynamicBlocks();
        }
    })
})();
